import { render } from "./ProductUpdate.vue?vue&type=template&id=252d2b21"
import script from "./ProductUpdate.vue?vue&type=script&lang=js"
export * from "./ProductUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__